import React, { Component } from 'react'
import BTC from '../../images/icon/btc.svg'
import BTCSelect from '../../images/icon/btcSelect.svg'
import ETH from '../../images/icon/eth.svg'
import ETHSelect from '../../images/icon/ethSelect.svg'
import USDT from '../../images/icon/usdt.svg'
import USDTSelect from '../../images/icon/usdtSelect.svg'
import ETH_USDT from '../../images/icon/usdtErc20.svg'
import ETH_USDTSelect from '../../images/icon/usdtErc20Select.svg'
import LTC from '../../images/icon/ltc.svg'
import LTCSelect from '../../images/icon/ltcSelect.svg'
import XRP from '../../images/icon/xrp.svg'
import XRPSelect from '../../images/icon/xrpSelect.svg'
import ETH_UAX from '../../images/icon/uax.svg'
import ETH_UAX_SELECT from '../../images/icon/uaxSelect.svg'
import UAH from '../../images/icon/hryvnia.svg'
import UAHSelect from '../../images/icon/hryvniaActive.svg'
import RUB from '../../images/icon/ruble.svg'
import RUBSelect from '../../images/icon/rubleActive.svg'
import DAIM from '../../images/icon/daim.svg'
import DAIMSelect from '../../images/icon/daimSelect.svg'
import USDC from '../../images/icon/usdc.svg'
import USDCSelect from '../../images/icon/usdcSelect.svg'
import TRX_USDT from '../../images/icon/usdtTrc20.svg'
import TRX_USDTSelect from '../../images/icon/usdtTrc20Select.svg'

import classes from "../Exchanger/Exchanger.module.css";
import CurrencyName from "./currency";
import IconCurrency from './currencyMobile'

export default class Icon extends Component {

    render = () => {
        const { currencyCode, checked, name, out, style } = this.props

        switch (currencyCode) {
            case 'ETH_UNI':
            case 'ETH_LINK':
            case 'ETH_SHIB':
            case 'BNB_SMART_ADA':
            case 'ETH_UAX':
            case 'ETH_USDT':
            case 'TRX_USDT':
            case 'ETH_DAIM':
            case 'ETH_USDC':
            case 'USDT':
                return (
                    <>
                        {name ?
                            <label htmlFor={out ? out : currencyCode}>
                                <div className={classes.item}>
                                    <IconCurrency
                                        currencyCode={currencyCode}
                                        checked={checked === currencyCode}
                                    />
                                    {name ?
                                        <div className={classes.value}>
                                            <CurrencyName currencyCode={currencyCode} />
                                        </div> : null}
                                </div>
                            </label>
                            :
                            <>
                                <IconCurrency
                                    currencyCode={currencyCode}
                                    checked={checked === currencyCode}
                                />
                                {name ?
                                    <div className={classes.value}>
                                        <CurrencyName currencyCode={currencyCode} />
                                    </div> : null}
                            </>
                        }
                    </>
                )
            case 'BCH':
            case 'BNB':
            case 'BNB_SMART':
            case 'ETC':
            case 'TON':
            case 'TRX':
            case 'DOGE':
            case 'XMR':
            case 'UAH':
            case 'RUB':
            case 'BTC':
            case 'ETH':
            case 'LTC':
            case 'XRP':
            case 'XLM':
                return (
                    <>
                        {name ?
                            <label htmlFor={out ? out : currencyCode}>
                                <div className={classes.item}>
                                    <IconCurrency
                                        currencyCode={currencyCode}
                                        checked={checked === currencyCode}
                                    />
                                    {name ?
                                        <div className={classes.value}>
                                            <CurrencyName currencyCode={currencyCode} />
                                        </div> : null}
                                </div>
                            </label>
                            :
                            <>
                                <IconCurrency
                                    currencyCode={currencyCode}
                                    checked={checked === currencyCode}
                                />
                                {name ?
                                    <div className={classes.value}>
                                        <CurrencyName currencyCode={currencyCode} />
                                    </div> : null}
                            </>
                        }
                    </>
                )
            default:
                return false;
        }
    }
}